import { useCallback } from 'react'
import { useApp } from '@wap-client/core'

const useTranslations = () => {
  let app
  try {
    app = useApp()
  } catch (err) {
    throw new Error(
      'useTranslations hook u yalnızca <AppProvider> içindeki componentlerde kullanılabilir.',
    )
  }

  if (!app.settings || typeof app.settings.translations !== 'object') {
    throw new Error(
      'useTranslations "da çağrılan useApp hookunun içerisinde `translations` nesnesi bulunamadı.',
    )
  }

  const { translations } = app.settings

  const translation = useCallback(
    (key: string): string => translations[key] ?? `{ ${key} }`,
    [translations],
  )

  return { translation }
}

export default useTranslations
